import { useMutation } from "react-query";
import { axiosPost } from "../../lib/axiosClient";

const useUpdateSelfTest = () => {
  return useMutation((test) => {
    return axiosPost("/api/cw/updateSelfTest", test);
  });
};

export default useUpdateSelfTest;
